import StipulatorContext from '@philips-emr/hpms-stipulator-commons/lib/contexts/stipulator-context';
import { TabWithContentAPI } from '@philips-emr/tws-components';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';
import { applicationContext } from '@philips-emr/tws-foundation';

@Controller({ fragment: 'contrato-dossie' })
export default class ContratoDossieController {

  @OnMount('contrato-dossie-content')
  onMountFilteredList(): void {
    applicationContext.openModule('dossie-contrato');
  }

  @OnMount('tab-with-content-indice-reajuste')
  onMountTabWithContentIndiceReajuste(event: MountEvent): void {
    const api = event.target as TabWithContentAPI;
    api.setVisible(StipulatorContext.isAllowedTwsFunction('9126_13'));
  }

  @OnMount('tab-with-content-tabela-preco')
  onMountTabWithContentTabelaPreco(event: MountEvent): void {
    const api = event.target as TabWithContentAPI;
    api.setVisible(StipulatorContext.isAllowedTwsFunction('9126_1'));
  }

}
